import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// front-user-json-controller
enum API {
  // listTradingFavorite
  UserTradingFavoriteList = '/hk-web/user/trading_favorite/list',
  // 获取用户业务状态
  UserBizStatus = '/hk-web/user/biz-status',
  // chcekregname
  UserCheckUserExist = '/hk-web/user/check_user_exist',
  // detelCoinAddress
  UserDelWithdrawAddress = '/hk-web/user/del_withdraw_address',
  // getGoogleTotpKey
  UserGetGoogleKey = '/hk-web/user/get_google_key',
  // userOauth
  UserOauth = '/hk-web/user/oauth.html',
  // saveWithdrawBtcAddr
  UserSaveWithdrawAddress = '/hk-web/user/save_withdraw_address',
  // userUpdateFavorite
  UserUserFavoriteJson = '/hk-web/user/user_favorite_json',
  // userLoginlog
  UserUserLoginlogJson = '/hk-web/user/user_loginlog_json',
  // userSettinglog
  UserUserSettinglogJson = '/hk-web/user/user_settinglog_json',
  // batchAddTradingFavorite
  UserTradingFavoriteBatchAdd = '/hk-web/user/trading_favorite/batch_add',
  // batchCancelTradingFavorite
  UserTradingFavoriteBatchCancel = '/hk-web/user/trading_favorite/batch_cancel',
}

export type TGetUserTradingFavoriteListParams = any
export type TGetUserTradingFavoriteListResponse = TResponse<any>
export const getUserTradingFavoriteList = (params?: TGetUserTradingFavoriteListParams) => {
  return hcAxios.get<TGetUserTradingFavoriteListResponse>(API.UserTradingFavoriteList, { params })
}

export type TGetUserBizStatusParams = any
export type TGetUserBizStatusResponse = TResponse<{
  tradeStatus?: number // 用户交易状态(1：已注册未入金，2：已入金未交易，3：入金且有过交易)
}>
export const getUserBizStatus = (params?: TGetUserBizStatusParams) => {
  return hcAxios.get<TGetUserBizStatusResponse>(API.UserBizStatus, { params })
}

export type TGetUserCheckUserExistParams = any
export type TGetUserCheckUserExistResponse = TResponse<any>
export const getUserCheckUserExist = (params?: TGetUserCheckUserExistParams) => {
  return hcAxios.get<TGetUserCheckUserExistResponse>(API.UserCheckUserExist, { params })
}

export type TPostUserCheckUserExistParams = any
export type TPostUserCheckUserExistResponse = TResponse<any>
export const postUserCheckUserExist = (params?: TPostUserCheckUserExistParams) => {
  return hcAxios.post<TPostUserCheckUserExistResponse>(API.UserCheckUserExist, params)
}

export type TGetUserDelWithdrawAddressParams = {
  fid?: any // fid
}
export type TGetUserDelWithdrawAddressResponse = TResponse<any>
export const getUserDelWithdrawAddress = (params?: TGetUserDelWithdrawAddressParams) => {
  return hcAxios.get<TGetUserDelWithdrawAddressResponse>(API.UserDelWithdrawAddress, { params })
}

export type TPostUserDelWithdrawAddressParams = {
  fid?: any // fid
}
export type TPostUserDelWithdrawAddressResponse = TResponse<any>
export const postUserDelWithdrawAddress = (params?: TPostUserDelWithdrawAddressParams) => {
  return hcAxios.post<TPostUserDelWithdrawAddressResponse>(API.UserDelWithdrawAddress, params)
}

export type TGetUserGetGoogleKeyParams = {
  totpCode?: any // totpCode
}
export type TGetUserGetGoogleKeyResponse = TResponse<any>
export const getUserGetGoogleKey = (params?: TGetUserGetGoogleKeyParams) => {
  return hcAxios.get<TGetUserGetGoogleKeyResponse>(API.UserGetGoogleKey, { params })
}

export type TPostUserGetGoogleKeyParams = {
  totpCode?: any // totpCode
}
export type TPostUserGetGoogleKeyResponse = TResponse<any>
export const postUserGetGoogleKey = (params?: TPostUserGetGoogleKeyParams) => {
  return hcAxios.post<TPostUserGetGoogleKeyResponse>(API.UserGetGoogleKey, params)
}

export type TGetUserOauthParams = {
  token?: any // token
}
export type TGetUserOauthResponse = TResponse<string>
export const getUserOauth = (params?: TGetUserOauthParams) => {
  return hcAxios.get<TGetUserOauthResponse>(API.UserOauth, { params })
}

export type TPostUserOauthParams = {
  token?: any // token
}
export type TPostUserOauthResponse = TResponse<string>
export const postUserOauth = (params?: TPostUserOauthParams) => {
  return hcAxios.post<TPostUserOauthResponse>(API.UserOauth, params)
}

export type TGetUserSaveWithdrawAddressParams = {
  password?: any // password
  phoneCode?: any // phoneCode
  remark?: any // remark
  symbol?: any // symbol
  totpCode?: any // totpCode
  withdrawAddr?: any // withdrawAddr
}
export type TGetUserSaveWithdrawAddressResponse = TResponse<any>
export const getUserSaveWithdrawAddress = (params?: TGetUserSaveWithdrawAddressParams) => {
  return hcAxios.get<TGetUserSaveWithdrawAddressResponse>(API.UserSaveWithdrawAddress, { params })
}

export type TPostUserSaveWithdrawAddressParams = {
  password?: any // password
  phoneCode?: any // phoneCode
  remark?: any // remark
  symbol?: any // symbol
  totpCode?: any // totpCode
  withdrawAddr?: any // withdrawAddr
}
export type TPostUserSaveWithdrawAddressResponse = TResponse<any>
export const postUserSaveWithdrawAddress = (params?: TPostUserSaveWithdrawAddressParams) => {
  return hcAxios.post<TPostUserSaveWithdrawAddressResponse>(API.UserSaveWithdrawAddress, params)
}

export type TGetUserUserFavoriteJsonParams = {
  operate?: any // 0:删除，1：增加
  tradeId?: any // 交易对ID
}
export type TGetUserUserFavoriteJsonResponse = TResponse<number[]>
export const getUserUserFavoriteJson = (params?: TGetUserUserFavoriteJsonParams) => {
  return hcAxios.get<TGetUserUserFavoriteJsonResponse>(API.UserUserFavoriteJson, { params })
}

export type TPostUserUserFavoriteJsonParams = {
  operate?: any // operate
  tradeId?: any // tradeId
}
export type TPostUserUserFavoriteJsonResponse = TResponse<any>
export const postUserUserFavoriteJson = (params?: TPostUserUserFavoriteJsonParams) => {
  const formData = new FormData()
  if (params?.operate) formData.append('operate', params.operate.toString())
  if (params?.tradeId) formData.append('tradeId', params.tradeId.toString())

  return hcAxios.post<TPostUserUserFavoriteJsonResponse>(API.UserUserFavoriteJson, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export type TGetUserUserLoginlogJsonParams = {
  currentPage?: any // currentPage
}
export type TGetUserUserLoginlogJsonResponse = TResponse<any>
export const getUserUserLoginlogJson = (params?: TGetUserUserLoginlogJsonParams) => {
  return hcAxios.get<TGetUserUserLoginlogJsonResponse>(API.UserUserLoginlogJson, { params })
}

export type TPostUserUserLoginlogJsonParams = {
  currentPage?: any // currentPage
}
export type TPostUserUserLoginlogJsonResponse = TResponse<any>
export const postUserUserLoginlogJson = (params?: TPostUserUserLoginlogJsonParams) => {
  return hcAxios.post<TPostUserUserLoginlogJsonResponse>(API.UserUserLoginlogJson, params)
}

export type TGetUserUserSettinglogJsonParams = {
  currentPage?: any // currentPage
}
export type TGetUserUserSettinglogJsonResponse = TResponse<any>
export const getUserUserSettinglogJson = (params?: TGetUserUserSettinglogJsonParams) => {
  return hcAxios.get<TGetUserUserSettinglogJsonResponse>(API.UserUserSettinglogJson, { params })
}

export type TPostUserUserSettinglogJsonParams = {
  currentPage?: any // currentPage
}
export type TPostUserUserSettinglogJsonResponse = TResponse<any>
export const postUserUserSettinglogJson = (params?: TPostUserUserSettinglogJsonParams) => {
  return hcAxios.post<TPostUserUserSettinglogJsonResponse>(API.UserUserSettinglogJson, params)
}

export type TPostUserTradingFavoriteBatchAddParams = {
  tradeIds?: number[]
}
export type TPostUserTradingFavoriteBatchAddResponse = TResponse<any>
export const postUserTradingFavoriteBatchAdd = (params?: TPostUserTradingFavoriteBatchAddParams) => {
  return hcAxios.post<TPostUserTradingFavoriteBatchAddResponse>(API.UserTradingFavoriteBatchAdd, params)
}

export type TPostUserTradingFavoriteBatchCancelParams = {
  tradeIds?: number[]
}
export type TPostUserTradingFavoriteBatchCancelResponse = TResponse<any>
export const postUserTradingFavoriteBatchCancel = (params?: TPostUserTradingFavoriteBatchCancelParams) => {
  return hcAxios.post<TPostUserTradingFavoriteBatchCancelResponse>(API.UserTradingFavoriteBatchCancel, params)
}
